import { useRouter } from 'next/router';
import { useEffect, useLayoutEffect, useState } from 'react';
import { RecoilState, Resetter, useResetRecoilState } from 'recoil';

/**
 *  페이지 이동시 atom을 초기화 해주는 hook
 * @param {RecoilState<T>} state 초기화해줄 atom
 *  */
function useReset<T>(state: RecoilState<T>): void {
  const { pathname } = useRouter();
  const [prevPathname, setPrevPathname] = useState<string>(pathname);

  const resetState: Resetter = useResetRecoilState(state);

  useLayoutEffect(() => {
    pathname !== prevPathname && setPrevPathname(pathname);
  }, [pathname]);

  useEffect(() => {
    resetState();
  }, [prevPathname]);
}

export default useReset;
